import { inject, Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DialogService } from 'shared/ui-common';

import { Attachment } from '@treetop/shared/model';

import { AttachmentDialogComponent } from './attachment-dialog/attachment-dialog.component';

export type AttachmentWithImported = Attachment & { imported?: boolean };

@Injectable({
  providedIn: 'root',
})
export class AttachmentDialogService {
  private dialogService = inject(DialogService);

  public openAttachmentDialog(chapter: UntypedFormGroup): void {
    const dialogRef = this.dialogService.open(AttachmentDialogComponent, {
      title: 'Attachments',
      maxWidth: 1000,
      panelClass: 'attachment-dialog',
      disableClose: true,
      data: {
        attachedResources: (chapter.controls.attachments.value as Attachment[]) || [],
      },
    });
    dialogRef.afterClosed().subscribe((result: { attachedResources: Attachment[] }) => {
      if (result) {
        chapter.controls.attachments.patchValue(result.attachedResources);
      }
    });
  }

  public openFlowchartAttachmentDialog(
    attachments: AttachmentWithImported[],
    assignAttachmentsCallback,
    deletedImportedAttachmentIds?: string[],
  ): void {
    const dialogRef = this.dialogService.open(AttachmentDialogComponent, {
      title: 'Assets',
      maxWidth: 1200,
      panelClass: 'attachment-dialog',
      disableClose: true,
      data: {
        attachedResources: attachments ? attachments : [],
        deletedImportedAttachmentIds: deletedImportedAttachmentIds ?? [],
      },
    });
    dialogRef.afterClosed().subscribe((result: { attachedResources: AttachmentWithImported[]; deletedImportedResourceIds: string[] }) => {
      if (result) {
        assignAttachmentsCallback(result.attachedResources, result.deletedImportedResourceIds);
      }
    });
  }
}
